import { useStore } from "../../store";
import { useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@lib/enums/QueryKeys";
import { useApi } from "@lib/helpers/useApi";
import { useEffect } from "react";
import { useProfile } from "@hooks/useProfile";
import type { Customer } from "@lib/api-services/services/profile-service/types";

export const useGetMyProfile = () => {
    const setMyProfile = useStore((state) => state.setMyProfile);

    const { data, isLoading, error, refetch, isFetching } = useProfile({
        queryConfig: {
            retry: false,
        },
    });

    useEffect(() => {
        if (data) {
            setMyProfile(data);
        }
    }, [data]);

    return {
        data,
        isLoading,
        error,
        refetch,
        isFetching,
    };
};

export const useUpdateProfile = () => {
    const queryClient = useQueryClient();

    const mutation = useApi.useMutate<any, Customer>(`/api/user/update-user`, {
        method: "PUT",
        onSuccess: () => {
            // Invalidate and refetch profile, so we have the new version updated
            queryClient.invalidateQueries({ queryKey: [QueryKeys.getProfile] });
        },
    });
    return { updateMyProfileMutation: mutation };
};
